import "./loading.css";

const LoadingSpinner = () => {
  return <div className="loader">Loading...</div>;
};

export default LoadingSpinner;
